<template>
   <div id="clientApp" v-bind:class="{'mobile-frame': isMobileFrame }">
      <div id="view">
         <router-view></router-view>
      </div>
   </div>
</template>

<script>
export default {
    name: 'clientApp',
    data() {
        return {
            isMobileFrame:
                location.href.includes('mobileFrame') ||
                sessionStorage.getItem('mobileFrame'),
        }
    },
    methods: {
        _handleResponsive() {
            if (this.isMobileFrame) {
                sessionStorage.setItem('mobileFrame', true)
                let metaTag = document.createElement('meta')
                metaTag.name = 'viewport'
                metaTag.content = 'width=device-width, initial-scale=1.0'
                document.getElementsByTagName('head')[0].appendChild(metaTag)
            }
        },
    },
    beforeMount() {
    },
    created() {
        this._handleResponsive()
    },
    watch: {
        $route() {
            $(document).scrollTop(0);
            if (!location.href.includes("maintenance")) {
                localStorage.removeItem("maintenanceSortObj");
            }
            if (!location.href.includes("malfunction") && !location.href.includes("Malfunction")) {
                localStorage.removeItem("malfunctionsSortObj");
            }
        }
    }
}
</script>

<style lang="less">
@import 'assets/css/style.less';
@import '~botoxs2/src/assets/css/config.less';
@import '~botoxs2/src/assets/css/table.less';

td {
   img {
      max-height: 22px !important;
   }
}

.modal-footer {
   border: none !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue